import HoursDeckIMG from "../../assets/DeckCards/Time/HoursDeckIMG.png";
import DaysOfTheWeekDeckIMG from "../../assets/DeckCards/Time/DaysOfTheWeekDeckIMG.png";
import DurationsDeckIMG from "../../assets/DeckCards/Time/DurationsDeckIMG.png";
import HoursMinsDeckIMG from "../../assets/DeckCards/Time/HoursMinsDeckIMG.png";
import MinutesDeckIMG from "../../assets/DeckCards/Time/MinutesDeckIMG.png";
import MonthsDeckIMG from "../../assets/DeckCards/Time/MonthsDeckIMG.png";
import PartsOfTheDayDeckIMG from "../../assets/DeckCards/Time/PartsOfTheDayDeckIMG.png";
import TimeWordsDeckIMG from "../../assets/DeckCards/Time/TimeWordsDeckIMG.png";


export const TimeDeckFace = [

    {
        id: "hours",
        Title: "Hours",
        Description: "Learn how to say the hours of the day!",
        Difficulty: "Beginner 2",
        Image: HoursDeckIMG,
        Link: "/HoursDeck",
        cssId: "Hours-ID"
    },
    {
        id: "minutes",
        Title: "Minutes",
        Description: "Learn how to pronounce minute intervals!",
        Difficulty: "Beginner 2",
        Image: MinutesDeckIMG,
        Link: "/MinutesDeck",
        cssId: "Minutes-ID"
    },
    {
        id: "hours-minutes",
        Title: "Hours + Minutes",
        Description: "Learn how to tell time with precision!",
        Difficulty: "Beginner 2",
        Image: HoursMinsDeckIMG,
        Link: "/HoursMinsDeck", 
        cssId: "Hours-Mins-ID"
    },
    {
        id: "days-of-the-week",
        Title: "Days of the Week",
        Description: "Learn the names of the seven days!",
        Difficulty: "Beginner 1",
        Image: DaysOfTheWeekDeckIMG,
        Link: "/DaysOfTheWeekDeck",
        cssId: "Days-Of-The-Week-ID"
    },
    {
        id: "months",
        Title: "Months",
        Description: "Learn how to say the twelve months!",
        Difficulty: "Beginner 1",
        Image: MonthsDeckIMG,
        Link: "/MonthsDeck",
        cssId: "Months-ID"
    },
    {
        id: "parts-of-the-day",
        Title: "Parts of the Day",
        Description: "Learn words like morning, afternoon, and night!",
        Difficulty: "Beginner 1",
        Image: PartsOfTheDayDeckIMG,
        Link: "/PartsOfTheDayDeck",
        cssId: "Parts-Of-The-Day-ID"
    },
    {
        id: "durations",
        Title: "Durations",
        Description: "Learn how to express durations and intervals!",
        Difficulty: "Beginner 2",
        Image: DurationsDeckIMG,
        Link: "/DurationsDeck",
        cssId: "Durations-ID"
    },
    {
        id: "time-words",
        Title: "Time Words",
        Description: "Learn useful vocabulary for talking about time!",
        Difficulty: "Beginner 2",
        Image: TimeWordsDeckIMG,
        Link: "/TimeWordsDeck",
        cssId: "Time-Words-ID"
    },

]
